const axios = require('axios');
const axiosInstance=axios.create();

module.exports = axiosInstance;